import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Add } from 'wix-ui-icons-common';
import Connection from '../connection';

import { LABELS } from '../../../constants';
import wixLogo from '../../../assets/Wix logo in flow.png';
import mcLogo from '../../../assets/MailChimp logo in flow.png';
import styles from './styles.scss';
import { TextButton } from 'wix-style-react';

class ConnectionList extends Component {
  static propTypes = {
    connections: PropTypes.array,
    wixContactLabels: PropTypes.array.isRequired,
    mailChimpContactLabels: PropTypes.array.isRequired,
    onConnect: PropTypes.func,
    onDelete: PropTypes.func,
    onCreateAnother: PropTypes.func,
    t: PropTypes.func,
  };

  state = {
    showCreateAnotherConnection: this.props.connections.length > 0,

    wixLabels: this.props.wixContactLabels.map((item) => ({
      id: item.id,
      text: this.props.t(`label.title.${item.id}`),
      description: this.props.t(`label.title.${item.id}-subtitle`),
    })),

    mailchimpLists: this.props.mailChimpContactLabels.map((item) => ({
      id: item.id,
      text: item.name,
    })),
  };

  render() {
    const { connections, onConnect, onDelete, onCreateAnother, t } = this.props;
    const {
      wixLabels,
      mailchimpLists,
      showCreateAnotherConnection,
    } = this.state;

    return (
      <div
        data-hook="connections-list"
        className={styles[`connections-list-container`]}
      >
        <div className={styles[`connection-list-container-scrollable-content`]}>
          <div className={styles.logos}>
            <img src={wixLogo} alt="" />
            <img className={styles.mailchimp} src={mcLogo} alt="" />
          </div>

          <div>
            {connections &&
              connections.map((connection) => (
                <Connection
                  connectionUID={connection.uid}
                  key={connection.uid}
                  srcItems={wixLabels}
                  initialSrcId={connection.fromWixLabelId}
                  dstItems={mailchimpLists}
                  initialDstId={connection.toMailChimpId}
                  onDelete={(uid) => onDelete(uid)}
                  type={connection.valid ? 'existing' : 'invalid'}
                  showSeperator
                />
              ))}
          </div>

          <div>
            {showCreateAnotherConnection && connections.length > 0 ? (
              <div
                className={styles[`create-another`]}
                onClick={() => {
                  this.setState({ showCreateAnotherConnection: false });
                  onCreateAnother && onCreateAnother();
                }}
              >
                <span className={styles.plus}>
                  <Add size="22px" />
                </span>
                <span data-hook="mi-mc-connections-list-create-another-button">
                  <TextButton>{t(`mailchimp.create.another`)}</TextButton>
                </span>
              </div>
            ) : (
              <Connection
                showSeperator={false}
                srcItems={wixLabels}
                initialSrcId={LABELS.NEW_SUBSCRIBERS}
                dstItems={mailchimpLists}
                onConnect={(srcId, dstId) => {
                  this.setState({ showCreateAnotherConnection: true });
                  onConnect(srcId, dstId);
                }}
              />
            )}
          </div>
          <div className={styles.gradient} />
          <div className={styles.placeholder} />
        </div>
      </div>
    );
  }
}

export default translate()(ConnectionList);
